// frontend/src/modules/router/decideRoute.js
// Reine Auth-Routing-Entscheidung. KEINE Vue/DOM-Abhaengigkeit, damit node:test sie laedt.
//
// status: 'active'|'grace'|'incomplete'|'suspended'|'deleted'|null
//   null = Cookie da, aber /account noch nicht geladen -> 'loadStatus'
// targetClass: 'public'|'protected'|'onboarding'

const ONBOARDING_ALLOWED = ['/onboarding/plan', '/onboarding/fertig'];

function decideRoute({ hasCookie, status, targetPath, targetClass, isImpersonation }) {
    // 1. Kein Login
    if (!hasCookie) {
        return targetClass === 'public' ? { action: 'allow' } : { action: 'redirect', path: '/login' };
    }

    // 2. Cookie da, Status noch unbekannt -> Guard muss laden
    if (status === null || status === undefined) {
        return { action: 'loadStatus' };
    }

    // Impersonation (B4b): Support darf auch suspended/deleted untersuchen.
    if (isImpersonation) {
        // Auf Auth-/Onboarding-Routen in die App leiten.
        // / ist jetzt das Dashboard (echte App-Seite) -- kein Sonderfall mehr noetig.
        if (targetClass === 'public' || targetClass === 'onboarding') {
            return { action: 'redirect', path: '/' };
        }
        return { action: 'allow' };
    }

    // 3. Status-Gating
    if (status === 'suspended' || status === 'deleted') {
        // Auf /login schon? dann allow (Terminierung)
        if (targetPath === '/login') return { action: 'allow' };
        return { action: 'redirect', path: '/login' };
    }

    if (status === 'incomplete') {
        if (ONBOARDING_ALLOWED.includes(targetPath)) return { action: 'allow' };
        return { action: 'redirect', path: '/onboarding/plan' };
    }

    // active | grace
    if (targetClass === 'public' || targetClass === 'onboarding') {
        return { action: 'redirect', path: '/' };
    }
    // / ist jetzt das Dashboard (echte App-Seite) -- kein Sonderfall mehr noetig.
    return { action: 'allow' };
}

module.exports = { decideRoute };
